"use strict";

exports.__esModule = true;
exports.DefaultBehaviors = void 0;
const DefaultBehaviors = exports.DefaultBehaviors = {
  selectable: true,
  removable: true
};
//# sourceMappingURL=behaviors.js.map